import type { FieldDefinition } from '../data/model';
import { attributeRuleField, attributeRuleFields } from '../rules/fields';
import type { PopupFieldConfiguration } from './model';
import { fieldDisplayLabel } from '../joins/effectiveLayer';

export const WIDE_POPUP_BODY_FIELD_THRESHOLD = 12;
export const WIDE_POPUP_INITIAL_VISIBLE_FIELD_COUNT = 10;

export function popupFields(fields: readonly FieldDefinition[]): readonly FieldDefinition[] {
  return attributeRuleFields(fields);
}

export function isPopupField(fields: readonly FieldDefinition[], fieldName: string): boolean {
  return attributeRuleField(fields, fieldName) !== null;
}

export function defaultPopupTitleField(fields: readonly FieldDefinition[]): string | null {
  const eligible = popupFields(fields);
  for (const preferredName of ['name', 'title']) {
    const match = eligible.find((field) => field.name.toLowerCase() === preferredName);
    if (match) return match.name;
  }
  return null;
}

export function createPopupFieldConfigurations(
  fields: readonly FieldDefinition[],
  titleField: string | null = null,
): readonly PopupFieldConfiguration[] {
  const eligible = popupFields(fields);
  const bodyFields = eligible.filter((field) => field.name !== titleField);
  const visibleBodyFieldCount =
    bodyFields.length > WIDE_POPUP_BODY_FIELD_THRESHOLD
      ? WIDE_POPUP_INITIAL_VISIBLE_FIELD_COUNT
      : bodyFields.length;
  const visibleBodyFields = new Set(
    bodyFields.slice(0, visibleBodyFieldCount).map((field) => field.name),
  );

  return eligible.map((field) => ({
    field: field.name,
    label: fieldDisplayLabel(field),
    visible: visibleBodyFields.has(field.name),
  }));
}

export function createInitialPopupConfiguration(fields: readonly FieldDefinition[]) {
  const titleField = defaultPopupTitleField(fields);
  return {
    titleField,
    fields: createPopupFieldConfigurations(fields, titleField),
  } as const;
}
